import React, { useState } from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
} from "@mui/material";

import { useAuth } from "../../context/AuthContext";

const RegisterDialog = ({ open, onClose, onLogin }) => {
  const { register, login } = useAuth();

  const [fullname, setFullname] = useState("");

  const [email, setEmail] = useState("");

  const [phone, setPhone] = useState("");

  const [password, setPassword] = useState("");

  const [confirmPassword, setConfirmPassword] = useState("");

  const [error, setError] = useState("");

  const [loading, setLoading] = useState(false);

  const handleRegister = async () => {
    setError("");

    if (!fullname || !email || !phone || !password) {
      setError("All fields are required.");

      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");

      return;
    }

    try {
      setLoading(true);

      const result = await register({
        fullname,

        email,

        phone,

        password,
      });

      if (result.success) {
        // Automatic login

        await login(email, password);

        clearForm();

        onClose();
      } else {
        setError(result.message);
      }
    } catch (error) {
      setError("Registration error.");
    } finally {
      setLoading(false);
    }
  };

  const clearForm = () => {
    setFullname("");

    setEmail("");

    setPhone("");

    setPassword("");

    setConfirmPassword("");
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Create Customer Account</DialogTitle>

      <DialogContent>
        <Box
          sx={{
            display: "flex",

            flexDirection: "column",

            gap: 2,

            mt: 1,
          }}
        >
          {error && <Alert severity="error">{error}</Alert>}

          <TextField
            label="Full Name"
            fullWidth
            value={fullname}
            onChange={(e) => setFullname(e.target.value)}
          />

          <TextField
            label="Email"
            type="email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <TextField
            label="Phone Number"
            fullWidth
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />

          <TextField
            label="Password"
            type="password"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <TextField
            label="Confirm Password"
            type="password"
            fullWidth
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          display: "flex",

          flexDirection: "column",

          gap: 1,

          px: 3,

          pb: 3,
        }}
      >
        <Button
          fullWidth
          variant="contained"
          disabled={loading}
          onClick={handleRegister}
        >
          {loading ? "Creating Account..." : "Register"}
        </Button>

        <Typography>
          Already have an account?
          <Button
            onClick={() => {
              onClose();

              onLogin();
            }}
          >
            Login
          </Button>
        </Typography>
      </DialogActions>
    </Dialog>
  );
};

export default RegisterDialog;
